export default "__VITE_ASSET__1705fffd__"